import { Slider } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';

import {
    blendImageState,
    imageBlendAmountState,
} from '~/state/atoms/image/imageAtoms';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { BlendImageSelector } from './BlendImageSelector';
import { useEffect } from 'react';
import { environmentState } from '~/state/atoms/engineAtoms';

export default function ImageBlending() {
    const environment = useRecoilValue(environmentState);
    const blendImage = useRecoilValue(blendImageState);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const [imageBlendAmount, setImageBlendAmount] = useRecoilState(
        imageBlendAmountState
    );

    useEffect(() => {
        if (environment) {
            const newAlpha = imageBlendAmount * 0.01;
            environment.updatePrimaryImageAlpha(newAlpha);
        }
    }, [imageBlendAmount]);

    const handleBlendAmountChange = (_: Event, newValue: number | number[]) => {
        setImageBlendAmount(newValue as number);
    };

    return selectedPatientId && blendImage ? (
        <Slider
            orientation="vertical"
            value={imageBlendAmount}
            onChange={handleBlendAmountChange}
            aria-label="Image blend"
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value}%`}
            sx={{
                position: 'absolute',
                right: -4,
                top: 0,
                zIndex: 9999,
                height: '100%',
                '& input[type="range"]': {
                    WebkitAppearance: 'slider-vertical',
                },
            }}
        />
    ) : (
        <BlendImageSelector />
    );
}
